import { PositionSlotListItem } from 'domain/people/positionSlots/types';
import { buildPositionSlotSummaryLine } from 'domain/people/positionSlots/utils/positionSlotDisplay';

export const POSITION_SLOT_LOAD_STATUS = {
  SUCCESS: 'success',
  NOT_FOUND: 'not_found',
  ERROR: 'error',
} as const;

export type PositionSlotLoadStatus = (typeof POSITION_SLOT_LOAD_STATUS)[keyof typeof POSITION_SLOT_LOAD_STATUS];

export type EmployeePositionSlotFormData = {
  employeeAlias: string;
  positionSlotId: string | null;
  positionSlotSummary: string | null;
  loadStatus: PositionSlotLoadStatus;
};

export const mapPositionSlotToFormData = (
  positionSlot: PositionSlotListItem | null,
  employeeAlias: string,
  options: {
    loadStatus?: PositionSlotLoadStatus;
  } = {},
): EmployeePositionSlotFormData => ({
  employeeAlias,
  positionSlotId: positionSlot?.id ?? null,
  positionSlotSummary: positionSlot ? buildPositionSlotSummaryLine(positionSlot) : null,
  loadStatus:
    options.loadStatus ?? (positionSlot ? POSITION_SLOT_LOAD_STATUS.SUCCESS : POSITION_SLOT_LOAD_STATUS.NOT_FOUND),
});

export const isPositionSlotLoadHttpError = (error: unknown): boolean => {
  if (typeof error !== 'object' || error === null || !('status' in error)) {
    return false;
  }

  const status = Number((error as { status?: number }).status);

  return Number.isFinite(status) && status >= 400;
};
